import { render, staticRenderFns } from "./FormDocumentUpload.vue?vue&type=template&id=1b35a9dc&scoped=true"
import script from "./FormDocumentUpload.vue?vue&type=script&lang=js"
export * from "./FormDocumentUpload.vue?vue&type=script&lang=js"
import style0 from "./FormDocumentUpload.vue?vue&type=style&index=0&id=1b35a9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b35a9dc",
  null
  
)

export default component.exports